import { instance } from "./core";
const cartApi =  async () => {
  const { data } = await instance.get("/cart");
  return data;
};
const regionsApi =  async (country) => {
  const { data } = await instance.get("/regions",{
    params:{country:country}
  });
  return data;
};
 
const orderState = async (dataSend, errorHandler) => {
  const res = await instance.post("/order/guest/state", dataSend).catch(errorHandler);
  if (res) return res.data;
};
const orderSend = async (dataSend, errorHandler) => {
  const res = await instance.post("/order/guest", dataSend).catch(errorHandler);
  if (res) return res.data;
};
const removeItemApi = async (id) => {
  const { data } = await instance.delete("/cart/item/" + id);
  return data;
};

const orderChangeTax = async (dataSend, errorHandler) => {
  const res = await instance
    .post("/changetaxgeozone", dataSend)
    .catch(errorHandler);
  if (res) return res.data;
};
const orderChangeDelivery = async (dataSend, errorHandler) => {
  const res = await instance
    .post("/cart/calc", dataSend)
    .catch(errorHandler);
  if (res) return res.data;
};
export {
  cartApi,
  orderState, 
  removeItemApi,
  orderSend,
  orderChangeTax,
  orderChangeDelivery,
  regionsApi
};
